import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Flex } from "@mantine/core";

import classes from "../../styles.module.css";
import src from "./successLottie.json?url";

export function FeedbackSuccessAnimation() {
    return (
        <Flex direction="unset" justify="center" align="center">
            <DotLottieReact className={classes.successAnimation} src={src} autoplay speed={1} loop={false} />
        </Flex>
    );
}
